import { Modal, Typography } from "antd";
import React from "react";

const BaseModal = (props) => {
  const modalClassName = ['klok-base-modal', props.className].filter(Boolean).join(' ');
  const rootClassName = ['klok-base-modal-root', props.rootClassName].filter(Boolean).join(' ');
  const bodyStyle = { padding: 0, ...props.bodyStyle };
  const modalStyle = { ...props.style };
  const requestedWidth = Number(props.width);
  const modalWidth = requestedWidth >= 1100 ? props.width : 680;
  const centered = props.centered ?? true;

  let title = (
    <div className="klok-modal-title">
      <span className="klok-modal-title__accent" aria-hidden="true" />
      <div className="klok-modal-title__copy">
        <Typography.Text className="klok-modal-title__main">{ props.mainTitle } { props.subTitle ? props.subTitle : '' }</Typography.Text>

      </div>
    </div>
  );

  return <Modal { ...props } centered={ centered } width={ modalWidth } style={ modalStyle } title={ title } className={ modalClassName } rootClassName={ rootClassName } bodyStyle={ bodyStyle }>
    <div className="basemodel" >
      { props.children }
    </div>
  </Modal>;
};

export default BaseModal;
